import { render } from "./ManageLibraryPermission.vue?vue&type=template&id=8804e6b6&scoped=true"
import script from "./ManageLibraryPermission.vue?vue&type=script&lang=js"
export * from "./ManageLibraryPermission.vue?vue&type=script&lang=js"

import "./ManageLibraryPermission.vue?vue&type=style&index=0&id=8804e6b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8804e6b6"]])

export default __exports__